import React, { useEffect, useState } from "react";
import { useLang } from "@/i18n";

const LangToggle = () => {
  const { lang, setLang } = useLang();
  return (
    <div className="flex items-center gap-1 font-accent text-sm tracking-widest" data-testid="language-toggle">
      {["it", "en"].map((l) => (
        <button
          key={l}
          onClick={() => setLang(l)}
          data-testid={`lang-${l}-btn`}
          className={`px-2 py-1 uppercase transition-colors duration-300 ${
            lang === l ? "text-[#D4AF37]" : "text-zinc-500 hover:text-zinc-200"
          }`}
        >
          {l}
        </button>
      )).reduce((acc, cur, i) => (i === 0 ? [cur] : [...acc, <span key={`s${i}`} className="text-zinc-700">/</span>, cur]), [])}
    </div>
  );
};

export default function Header() {
  const { t } = useLang();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    ["about", t.nav.about],
    ["services", t.nav.services],
    ["finishes", t.nav.finishes],
    ["machinery", t.nav.machinery],
    ["sectors", t.nav.sectors],
    ["work", t.nav.work],
  ];

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled ? "backdrop-blur-xl bg-black/70 border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <a href="#top" data-testid="logo-link" className="flex items-baseline gap-2 group">
          <span className="font-display text-2xl font-semibold tracking-tight text-white">OLMI</span>
          <span className="font-accent text-xs tracking-[0.3em] text-[#D4AF37] uppercase">Srl</span>
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {links.map(([id, label]) => (
            <a
              key={id}
              href={`#${id}`}
              data-testid={`nav-${id}`}
              className="font-accent text-sm uppercase tracking-widest text-zinc-300 hover:text-white link-underline"
            >
              {label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-5">
          <LangToggle />
          <a
            href="#contact"
            data-testid="header-contact-btn"
            className="btn-fill hidden sm:inline-block border border-white/25 px-5 py-2.5 font-accent text-xs uppercase tracking-widest text-white hover:text-black"
          >
            {t.nav.contact}
          </a>
        </div>
      </div>
    </header>
  );
}
